module.exports = __webpack_public_path__ + "app/assets/images/man2-ce0ccbc702617a27bf729ccb34d46089.jpg";